module.exports = __webpack_public_path__ + "static/media/smk_logo.4031296d.jpg";